import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Home/index.vue'
import Long from '../views/Home/index.vue'
import login from '../views/Home/login.vue'
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'login',
        component: login,
        redirect: "",

        children: []
    },
    {
        path: '/Index',
        name: 'Index',
        component: Index,
        redirect: "",

        children: []
    },
    {
        path: '/Long',
        name: 'Long',
        component: Long,
        redirect: "",

        children: []
    },
]

const router = new VueRouter({
    routes
})
export default router